import React from 'react';
import { Modal, Spinner } from './ui';
import { useReportShare } from './useReportShare';
import { REPORT_SIZE_OPTIONS } from '../utils/reportExport';

// Phone Share / Export: big buttons, no side panel. Format / rows / page are
// thumb-sized segmented switches; the preview is a short strip (a PDF in a
// phone-sized frame is barely readable), and "Share file" hands the file to
// WhatsApp, Drive or mail through the OS sheet.
const Seg = ({ value, options, onChange }) => (
  <div className="pp-seg">
    {options.map(([v, label]) => (
      <button key={v} type="button" className={value === v ? 'on' : ''} onClick={() => onChange(v)}>{label}</button>
    ))}
  </div>
);

export default function ReportShareMobile(props) {
  const vm = useReportShare(props);
  const {
    kind, setKind, orientation, setOrientation, density, setDensity, busy, previewUrl, fileName, pages, setPages, pageLabel,
    rowCount, columnCount, sections, title, subtitle, save, print, shareFile, canShareFile, close,
  } = vm;

  return (
    <Modal
      fullScreen title={`Share / Export — ${title}`} onClose={close}
      footer={<>
        <button className="btn light" onClick={close}>Close</button>
        <button className="btn primary" style={{ flex: 1, padding: 12 }} data-save="primary"
          disabled={!!busy} onClick={() => (canShareFile ? shareFile() : save())}>
          {busy ? 'Working…' : canShareFile ? '↗ Share file' : '↓ Save file'}
        </button>
      </>}
    >
      <div className="pp-share-m">
        <div className="step-label">Format</div>
        <Seg value={kind} onChange={setKind} options={[['pdf', '📄 PDF'], ['excel', '📊 Excel']]} />

        {kind === 'pdf' && (
          <>
            <div className="step-label">Pages</div>
            <div className="chips-row" style={{ marginBottom: 4 }}>
              <input className="rs-pages" value={pages} placeholder="all" inputMode="numeric"
                onChange={(e) => setPages(e.target.value.replace(/[^\d,\-\s]/g, ''))} />
              {pages.trim() && <button type="button" className="btn light sm" onClick={() => setPages('')}>All</button>}
            </div>
            {pageLabel && <div className="muted" style={{ fontSize: 12, marginBottom: 8 }}>{pageLabel}</div>}
            <div className="step-label">Text size</div>
            <Seg value={density} onChange={setDensity} options={REPORT_SIZE_OPTIONS} />
            <div className="step-label">Page</div>
            <Seg value={orientation} onChange={setOrientation} options={[['portrait', 'Portrait'], ['landscape', 'Landscape']]} />
          </>
        )}
      </div>

      <div className="muted" style={{ fontSize: 12.5, marginBottom: 10, lineHeight: 1.6 }}>
        {subtitle && <div>{subtitle}</div>}
        <div>{rowCount} {rowCount === 1 ? 'row' : 'rows'} · {columnCount} {sections ? (columnCount === 1 ? 'section' : 'sections') : 'columns'}</div>
        <div style={{ wordBreak: 'break-all' }}>{fileName}</div>
      </div>

      {kind === 'pdf' && (
        busy === 'preview' || !previewUrl
          ? <div className="card card-pad" style={{ display: 'grid', placeItems: 'center', height: 180 }}><Spinner /></div>
          : <iframe title="Report preview" src={previewUrl} className="share-frame" style={{ height: 300 }} />
      )}

      <div className="pp-share-actions">
        <button className="btn light" disabled={!!busy} onClick={() => save('pdf')}>↓ PDF</button>
        <button className="btn light" disabled={!!busy} onClick={() => save('excel')}>↓ Excel</button>
        <button className="btn light" disabled={!!busy} onClick={print}>🖨 Print</button>
      </div>
    </Modal>
  );
}
